/* eslint-disable consistent-return */
import { loadTranslations, setLocale } from 'react-redux-i18n';
import RestClient from './config/rest-client';
import { applyDateLocale } from './lib/locale';

export function loadLocale() {
  return async (dispatch) => {
    const [translate, language] = await Promise.all([
      RestClient.get(
        'translate', ''
      ),
      RestClient.get(
        'translate', 'language'
      ),
    ])
    dispatch({ type: 'SET_AUTH_KEY', key: 'languages', data: language });

    const objTranslate = {};
    translate.forEach(item => {
      if (objTranslate[item.lang]) {
        objTranslate[item.lang][item.code] = item.message;
      } else {
        objTranslate[item.lang] = { [item.code]: item.message }
      }
    })

    dispatch(loadTranslations(objTranslate));


    if (!localStorage.getItem('languageSite')) {
      localStorage.setItem('languageSite', 'en-US');
    }

    const lang = localStorage.getItem('languageSite');


    dispatch(setLocale(lang));
    applyDateLocale(lang);
  };
}

export function me() {
  return async (dispatch) => {
    try {
      dispatch({ type: 'IS_LOADED', data: false });

      await dispatch(loadLocale());

      const { profile } = await RestClient.get(
        'auth',
        'profile'
      );
      const limits = await RestClient.get('settings', 'limits');
      const stats = await RestClient.get('dashboard', '', {});

      dispatch({ type: 'SET_AUTH_KEY', key: 'stats', data: stats });

      dispatch({ type: 'SET_AUTH_KEY', key: 'free_limit', data: limits });

      dispatch({ type: 'SET_PROFILE', data: profile });

      dispatch({ type: 'IS_LOADED', data: true });
    } catch (error) {
      console.log("🚀 ~ file: actions.js:40 ~ return ~ error:", error)
      setTimeout(() => {
        dispatch({ type: 'IS_LOADED', data: true });
      }, 500);
    }
  };
}

export function exit() {
  return async (dispatch) => {
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    RestClient.config({
      headers: {
        Accept: 'application/json',
        Authorization: undefined,
        'Content-Type': 'application/json',
      },
    });
    dispatch({ type: 'LOGOUT' });
    // history.push('/login');
  };
}
